
import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import LogUtils from 'panda-log';
import { toast } from '../../../utils/common';
import { PublicQuery } from '@/mixins/public_query';
import { getAreaSamll, postAddGame, UpdateGame } from '@/api/game-manage';
import { eAccountType, iGameModel, iSelectGameType, eActFreeType } from '@/interface/game-manage';
import { iUploadeImagesList } from '@/interface/imageUpload';
import GameType from '@/components/game-type/game-type.vue';
import AccountInfo from './account-info.vue';
import Upload from '@/components/ImagesUpload/upload.vue';
import { watch } from 'fs';

@Component({
  components: { GameType, Upload, AccountInfo },
})
export default class EditGame extends Vue {
  publicQuery = new PublicQuery();
  @Prop() visibleDialog!: Boolean;
  @Prop() model!: iGameModel;
  @Prop() title!: string;
  @Prop() mainImgUpload!: iUploadeImagesList[];
  @Prop() gameMediaUpload!: iUploadeImagesList[];
  typeVisible: Boolean = false;
  activeName: string = 'first';
  isSelectBlackList: number = 0;
  selectBlackType: number = 0;
  areaOptions: any = [];
  areaList: any = [];
  allSelectAreas: any = [];
  areaProps: object = { multiple: true, value: 'id', label: 'name', children: 'children' };
  gameTypeModel: iSelectGameType = {
    id: 0,
    name: '',
  };
  onLine: eAccountType = eAccountType.ONLINE;
  isFree: eActFreeType = eActFreeType.FREE;
  gameTypeList = [
    {
      name: '请选择游戏',
      id: -1,
    },
    {
      name: 'ces',
      id: 3233,
    },
  ];
  radioList = [
    {
      name: '否',
      id: 0,
    },
    {
      name: '是',
      id: 1,
    },
  ];
  onLineList = [
    {
      name: '离线',
      id: eAccountType.OFFLINE,
    },
    {
      name: '在线',
      id: eAccountType.ONLINE,
    },
  ];
  blackRadioList = [
    {
      name: '否',
      id: 0,
    },
    {
      name: '是',
      id: 1,
    },
  ];
  blackRadioTypeList = [
    {
      name: '全部选区',
      id: 0,
    },
    {
      name: '选择选区',
      id: 1,
    },
  ];
  /* 虚拟键盘 */
  virtualKeyList: any = [];
  loading = false;
  rules = {
    name: [{ required: true, message: '请输入游戏名称', trigger: 'blur' }],
    category_id: [{ required: true, message: '请选择游戏类别', trigger: 'blur', pattern: /^\+?[1-9]\d*$/ }],
    gid: [{ required: true, message: '请输入GID', trigger: 'blur' }],
    // path: [{ required: true, message: '请输入游戏启动路径', trigger: 'blur' }],
    file_id: [{ required: true, message: '请选择虚键盘', trigger: 'blur', pattern: /^\+?[1-9]\d*$/ }],
    intro: [
      { required: true, message: '游戏介绍不能为空', trigger: 'blur' },
      { required: true, message: '游戏介绍不能超过1000', trigger: 'blur', max: 1000, min: 1 },
    ],
    mainImgUpload: [{ required: true, validator: this.getMainImgLength, trigger: 'blur' }],
    gameMediaUpload: [{ required: true, validator: this.getGameMediaLength, trigger: 'blur' }],
    steam_gid: [{ required: true, validator: this.getStreamID, trigger: 'blur' }],
    // archive_path: [{ required: true, message: '请输入存档路径', trigger: 'blur' }],
    // process_name: [{ required: true, validator: this.getProcessName, trigger: 'blur' }],
  };
  getGameMediaLength(rule: any, value: any, callback: any) {
    // console.log(this.gameMediaUpload);
    if (this.gameMediaUpload && this.gameMediaUpload.length > 0) {
      return callback();
    }
    return callback(new Error('游戏介绍图不能为空'));
  }
  getStreamID(rule: any, value: any, callback: any) {
    const { act_free, account_mode, steam_gid } = this.model;
    if (act_free == this.isFree && account_mode == this.onLine && steam_gid == '') {
      return callback(new Error('请输入steamID'));
    }
    return callback();
  }
  getMainImgLength(rule: any, value: any, callback: any) {
    if (this.mainImgUpload && this.mainImgUpload.length > 0) {
      return callback();
    }
    return callback(new Error('游戏详细主图不能为空'));
  }
  getProcessName() {
    if (this.model.process_name) {
      if (!this.model.process_watch_min || this.model.process_watch_min == 0) {
        toast('请填入进程时间', 'error');
        return false;
      }
    }
    return true;
  }

  submitForm(formName: string) {
    if (!this.getProcessName()) return;

    (this.$refs[formName] as any).validate((valid: any) => {
      if (valid) {
        this.postAddGame();
      } else {
        console.log('error submit!!');
        return false;
      }
    });
  }
  @Emit()
  close() {}
  async postAddGame() {
    try {
      this.model.main_img = this.mainImgUpload[0].url; //主图
      this.model.game_media = JSON.parse(JSON.stringify(this.gameMediaUpload));
      if (this.model.id && this.model.id <= 0) {
        delete this.model.id;
      }
      //选中黑名单 否
      if (this.isSelectBlackList == 0) {
        this.model.sbl = [];
      } else {
        //全部为黑名单
        if (this.selectBlackType == 0) {
          this.model.sbl = [0];
        } else {
          if (this.allSelectAreas.length == 0) {
            toast('请选择要搜索的黑名单区域', 'error');
            return;
          }
          this.model.sbl = this.allSelectAreas.map((item: any) => item[1]);
        }
      }

      if (!this.model.process_name) {
        this.model.process_watch_min = 3;
      }

      const value = this.allSelectAreas.map((item: any) => item[0]);

      this.loading = true;
      this.$msgbox({
        title: '提示',
        message: `请核对信息是否正确？确认${this.model.id > 0 ? '修改' : '添加'} ？`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        beforeClose: async (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = '执行中...';
            let res: any;
            if (this.model.id && this.model.id > 0) {
              res = await UpdateGame(this.model);
            } else {
              res = await postAddGame(this.model);
            }
            if (res.code == 0) {
              toast('操作成功！');
              this.$emit('ok');
            } else {
              toast(res.msg, 'error');
            }

            done();
            instance.confirmButtonLoading = false;
          } else if (action === 'cancel') {
            instance.confirmButtonLoading = false;
            done();
          }
        },
      })
        .then(() => {
          // done();
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {});
    } catch (error) {
      LogUtils.debug(error);
    } finally {
      this.loading = false;
    }
  }
  /* 游戏类别 */
  async getGameTypeList() {
    const res: any = await this.publicQuery.getGameTypeList();
    //console.log('游戏类别');
    if (res) {
      this.gameTypeList = res;
    }
  }
  /* 虚拟键盘 */
  async getVirtualKeyboard(key: string) {
    const res: any = await this.publicQuery.getVirtualKeyboard(key);
    if (res) {
      this.virtualKeyList = res;
    }
  }
  // searchVirtualKey(query: string) {
  //   console.log(query);

  //   if (query.trim() != '') {
  //     this.getVirtualKeyboard(query);
  //   }
  // }
  /* 小区列表(支持大区级联) */
  async getAreaSmall() {
    const res: any = await getAreaSamll();
    const { code, data } = res;
    if (code == 0) {
      this.areaList = data;
      this.getCompareToTwo(data);
      if (this.model.id > 0) {
        this.bindArea();
      }
    }
  }
  //一维转二维数组
  getCompareToTwo(data: any) {
    //找出父级
    let parantData: any = [];
    data.forEach((item: any) => {
      let isTrue = parantData.find((i: any) => i.id == item.pid);
      if (!isTrue || parantData == []) {
        parantData.push({ id: item.pid, name: item.pname, children: [] });
      }
    });
    parantData.forEach((m: any) => {
      data.forEach((n: any) => {
        if (n.pid == m.id) {
          m.children.push(n);
        }
      });
    });
    this.areaOptions = parantData;
  }
  handleChange(value: any) {
    this.allSelectAreas = value;
  }
  mounted() {
    this.getGameTypeList();
    this.getVirtualKeyboard('');
    this.getAreaSmall();
  }
  bindArea() {
    //区域赋值
    const { sbl } = this.model;
    let sblLength: number = sbl.length;
    //// 搜索黑名单选区ID列表数组，[0]为全部选区 []不是搜索黑名单 [1,2,3,4]其他的数组表示为搜索黑名单的选区ID
    if (sblLength == 0) {
      this.isSelectBlackList = 0;
    } else {
      this.isSelectBlackList = 1;
      if ((sblLength == 0 && this, sbl[0] == 0)) {
        this.selectBlackType = 0;
      } else {
        this.selectBlackType = 1;
        this.allSelectAreas = sbl.map((m: any) => {
          let item = this.areaList.filter((n: any) => m == n.id)[0];
          return [item.pid, m];
        });
      }
    }
  }
  @Watch('title')
  onChange(newValue: any, oldValue: any) {
    if (newValue != oldValue && newValue == '新增游戏') {
      this.activeName = 'first';
    }
  }
}
